import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useState } from 'react';
import FJLocalStore from '../../../../store/FJLocalStore';
import CreditsSmallIcon from '../../../../assets/svg/modelPanel/credit.svg?react';
import styles from './FJModelItem.module.less';
import FJModelTagsBadges from './FJModelTagsBadges';

const FJModelItem = ({ data, isSelected, onClick, currentMode = null }) => {
    return (
        <div
            className={classNames(styles.model_item, {
                [styles.model_item_active]: isSelected,
            })}
            onClick={() => onClick(data)}
        >
            <div className={styles.model_item_icon_box}>
                <img src={data.renderIcon} alt={data.name} className={styles.model_item_icon} />
            </div>

            <div className={styles.model_item_info_box}>
                <div className={styles.model_item_info_top}>
                    <div className={styles.model_item_name}>{FJLocalStore._(data.name)}</div>
                    <div className={styles.model_item_credit}>
                        <CreditsSmallIcon />
                        <span>{data.useCredit}</span>
                    </div>
                    {data.isNew && <div className={styles.model_item_new}>{FJLocalStore._('new')}</div>}
                </div>
                <FJModelTagsBadges
                    badgeItemClass={styles.badge_item}
                    features={currentMode ? data.tagsByMode?.[currentMode] || [] : data.tags || []}
                />
            </div>
        </div>
    );
};

FJModelItem.propTypes = {
    data: PropTypes.shape({
        name: PropTypes.string.isRequired,
        renderIcon: PropTypes.string,
        useCredit: PropTypes.number,
        isNew: PropTypes.bool,
        tagsByMode: PropTypes.object,
        categoryByMode: PropTypes.object,
        tags: PropTypes.array, // For backward compatibility (text-to-image/photo-editor)
        categorys: PropTypes.array, // For backward compatibility (text-to-image/photo-editor)
    }).isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    currentMode: PropTypes.string,
};

export default FJModelItem;
